import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/ContractBasis/ContractBasis.requests'
import ContractBasisDetails from '../ContractBasisDetails'

const ContractBasisCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <ContractBasisDetails
            onSuccess={onSuccess}
            requestParams={requests.create()}
        />
    )
}

export default ContractBasisCreate
